import { useEffect } from 'react';
import { usePreferredCDNs } from '@core/helpers/video/usePreferredCDNs';
import { useVideoWrapperFactory } from '@core/video/videoElementWrapper';
const PRELOAD_THRESHOLD = 60 * 5;
/**
 * Preloads video if it is in viewport for faster first frame
 */
export const usePreloadVideo = ({ video, params, enabled }) => {
    const preferredCDNs = usePreferredCDNs(params);
    const videoWrapper = useVideoWrapperFactory({
        video,
        key: video.encoded_id,
        enabled,
        preferredCDNs,
    });
    useEffect(() => {
        if (!videoWrapper) {
            return;
        }
        if (videoWrapper.preload !== 'auto' && video.duration < PRELOAD_THRESHOLD) {
            videoWrapper.preload = 'auto';
        }
    }, [videoWrapper, enabled, video]);
    return videoWrapper;
};
